// export default Number.prototype.formatRupee = function () {
//   const parts = this.toString().split(".");
//   parts[0] = parts[0].replace(/\B(?=(\d{2})+(?=\d{3}(\.|$)))/g, ",");
//   return parts.join(".");
// };

export default Number.prototype.formatRupee = function () {
  return this.toString().replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,");
};
